import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { TimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { INDDIntlFormat } from 'ndd-ng-intl';
import { takeUntil } from 'rxjs/operators';

import { NDDFormErrorService } from '@shared/ndd-ng-forms/ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBaseComponent } from '@shared/ndd-ng-forms/shared/ndd-ng-forms.base-component';

/** Definições para `controlIncrementalSteps`. */
type NDDFormTimePickerIncrementalSteps = { hour: number, minute: number, second: number };

/** Componente timepicker. */
@Component({
    selector: 'ndd-ng-form-timepicker',
    template: require('./ndd-ng-form-timepicker.component.html'),
})
export class NDDFormTimePickerComponent extends NDDFormsBaseComponent implements OnInit, AfterViewInit {
    /** Valor do controle. */
    @Input() public controlValue: Date;

    /** Padrão de formatação do tempo. */
    @Input() public controlFormat: INDDIntlFormat;
    /** Medida de adição/subtração para os valores. */
    @Input() public controlIncrementalSteps: NDDFormTimePickerIncrementalSteps = { hour: 1, minute: 1, second: 1 };
    /** Define tempo máximo. */
    @Input() public controlMax: Date;
    /** Define tempo mínimo. */
    @Input() public controlMin: Date;

    /** Evento de exibição do relógio. */
    @Output() public onControlToggleClock: EventEmitter<boolean> = new EventEmitter<boolean>();

    /** Componente Kendo TimePicker. */
    @ViewChild(TimePickerComponent, { static: false }) public kendoTimePicker: TimePickerComponent;

    constructor(
        @Inject(Window) private window: Window,
        private elemRef: ElementRef,
        formErrorService: NDDFormErrorService,
        cdr: ChangeDetectorRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        this.controlFormat = this.controlFormat ? this.controlFormat : { format: 't' };

        super.addControl();

        if (this.controlRequired) {
            super.cacheValidator(Validators.required);
        }

        super.addValidators();

        this.control.valueChanges.pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((value: Date) => {
                this.controlValue = value;
                this.controlValueChange.emit(value);
            });
    }

    public ngAfterViewInit(): void {
        const input: HTMLElement = this.kendoTimePicker.wrapper.nativeElement.querySelector('.k-dateinput-wrap > .k-input');

        input.setAttribute('id', this.controlId);
        input.setAttribute('name', this.controlKey);

        if (this.controlDisabled) {
            this.control.disable();

            return;
        }

        if (this.controlAutofocus) {
            this.kendoTimePicker.focus();
        }
    }

    /** Verifica cliques fora do componente. */
    @HostListener('document:click', ['$event'])
    public offClick(event: any): void {
        // Caso o clique tenha sido fora do calendário, fecha-o.
        if (this.kendoTimePicker.isOpen
            && !this.elemRef.nativeElement.getElementsByClassName('ndd-ng-form-internal-timepicker')[0].contains(event.target)
            && !this.window.document.querySelector('.k-timeselector').contains(event.target)) {
            this.toggle(false);
        }
    }

    public toggle(toOpen: boolean): void {
        this.kendoTimePicker.toggle(toOpen);
        this.onControlToggleClock.emit(toOpen);
    }
}
